module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Lauren Nightingale – You are one of the best humans that I know, and I’m lucky enough to call you my best friend. Thank you for always being there for me, your loyal friendship and support means everything.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Abi Curtis – My absolute angel. Thank you for everything you have done for me over the past couple of years, your emotional support throughout the toughest time of my life will never be forgotten, your kindness and compassion will always shine so brightly.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Matty Britt – Thank you for challenging me, you inspire me to be better. Your knowledge and advice will always be appreciated as well as your friendship, and the cheese on toast!")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Steve and Brenda Curtis – Thank you so much for the endless advice, the confidence to grow professionally and personally, and for always making me laugh. You both have a special place in my heart.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Anne-Marie Eady and Amanda Smith – Thank you for the love and kindness you have shown me and not forgetting the cuddles. I was incredibly lucky to have such a great support system when I needed it most.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thank you to the team at Austing Macauley for making my dreams come true. A special thank you to Karen Walker for making my ideas and visions come to life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be8e4d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0